import { gql } from '__generated__/gql';
import { gql as apolloGql } from '@apollo/client';

export const LIST_COMPANY_CONTRACTS_QUERY = gql(`
  query ListCompanyContracts($publicCompanyId: Int!) {
    companyContracts(publicCompanyId: $publicCompanyId) {
      id
      publicCompanyId
      type
      validFrom
      validTo
      invoiceInterval
      amountCents
      description
      isActive
      nextInvoiceDate
      sapStatus
      sapLastSyncedAt
      sapError
      createdAt
      updatedAt
    }
  }
`);

export const VIEW_COMPANY_CONTRACT_QUERY = gql(`
  query ViewCompanyContract($id: Int!) {
    companyContract(id: $id) {
      id
      publicCompanyId
      type
      validFrom
      validTo
      invoiceInterval
      amountCents
      description
      isActive
      nextInvoiceDate
      sapStatus
      sapLastSyncedAt
      sapError
      createdAt
      updatedAt
      documents {
        id
        contractId
        filename
        mimeType
        size
        storageKey
        uploadedBy
        createdAt
        updatedAt
      }
      invoiceLogs {
        id
        contractId
        triggeredAt
        invoiceDate
        trigger
        sapStatus
        sapPayloadRef
        error
        createdAt
        updatedAt
      }
    }
  }
`);

export const CREATE_COMPANY_CONTRACT_MUTATION = gql(`
  mutation CreateCompanyContract($input: CompanyContractCreateInput!) {
    createCompanyContract(input: $input) {
      id
      publicCompanyId
      type
      validFrom
      validTo
      invoiceInterval
      amountCents
      description
      isActive
      nextInvoiceDate
      sapStatus
      createdAt
      updatedAt
    }
  }
`);

export const UPDATE_COMPANY_CONTRACT_MUTATION = gql(`
  mutation UpdateCompanyContract($id: Int!, $input: CompanyContractUpdateInput!) {
    updateCompanyContract(id: $id, input: $input) {
      id
      publicCompanyId
      type
      validFrom
      validTo
      invoiceInterval
      amountCents
      description
      isActive
      nextInvoiceDate
      sapStatus
      createdAt
      updatedAt
    }
  }
`);

export const DELETE_COMPANY_CONTRACT_MUTATION = gql(`
  mutation DeleteCompanyContract($id: Int!) {
    deleteCompanyContract(id: $id)
  }
`);

export const CREATE_COMPANY_MANUAL_INVOICE_MUTATION = gql(`
  mutation CreateCompanyManualInvoice($contractId: Int!, $invoiceDate: String!) {
    createCompanyManualInvoice(contractId: $contractId, invoiceDate: $invoiceDate) {
      id
      contractId
      triggeredAt
      invoiceDate
      trigger
      sapStatus
      sapPayloadRef
      error
      createdAt
      updatedAt
    }
  }
`);

export const UPLOAD_COMPANY_CONTRACT_DOCUMENT_MUTATION = gql(`
  mutation UploadCompanyContractDocument(
    $contractId: Int!
    $filename: String!
    $base64Data: String!
  ) {
    uploadCompanyContractDocument(
      contractId: $contractId
      filename: $filename
      base64Data: $base64Data
    ) {
      id
      contractId
      filename
      mimeType
      size
      storageKey
      uploadedBy
      createdAt
      updatedAt
    }
  }
`);

export const DELETE_COMPANY_CONTRACT_DOCUMENT_MUTATION = gql(`
  mutation DeleteCompanyContractDocument($id: Int!) {
    deleteCompanyContractDocument(id: $id)
  }
`);

export const COMPANY_CONTRACT_DOCUMENT_URL_QUERY = apolloGql(`
  query CompanyContractDocumentUrl($id: Int!) {
    companyContractDocumentUrl(id: $id)
  }
`);